var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parking-filter" }, [
    _vm.price
      ? _c(
          "div",
          { staticClass: "parking-filter__slider" },
          [
            _c("div", { staticClass: "parking-filter__slider-title" }, [
              _vm._v("Стоимость машиноместа, руб."),
            ]),
            _vm._v(" "),
            _c("RangeSlider", { attrs: { slider: _vm.price, name: "price" } }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.floor
      ? _c(
          "div",
          {
            staticClass: "parking-filter__filter parking-filter__filter-floor",
          },
          [
            _c("div", { staticClass: "parking-filter__slider-title" }, [
              _vm._v("Этаж"),
            ]),
            _vm._v(" "),
            _c("CheckBoxList", { attrs: { filter: _vm.floor } }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.area
      ? _c(
          "div",
          { staticClass: "parking-filter__filter parking-filter__filter-size" },
          [
            _c("div", { staticClass: "parking-filter__slider-title" }, [
              _vm._v("Размер"),
            ]),
            _vm._v(" "),
            _c("CheckBoxList", { attrs: { filter: _vm.area } }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "parking-filter__reset", on: { click: _vm.resetFilter } },
      [
        _c("span", [_vm._v("Сбросить параметры")]),
        _vm._v(" "),
        _c(
          "svg",
          {
            attrs: {
              width: "8",
              height: "9",
              viewBox: "0 0 8 9",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3.99996 5.72223L1.37727 8.34492C1.12213 8.60007 0.641687 8.5333 0.304183 8.1958C-0.0333213 7.85829 -0.100086 7.37786 0.15506 7.12271L2.77775 4.50002L0.155017 1.87729C-0.100129 1.62214 -0.0333644 1.1417 0.30414 0.804197C0.641644 0.466693 1.12208 0.399928 1.37723 0.655074L3.99996 3.27781L6.62282 0.654956C6.87796 0.39981 7.3584 0.466574 7.6959 0.804079C8.03341 1.14158 8.10017 1.62202 7.84503 1.87717L5.22217 4.50002L7.84498 7.12283C8.10013 7.37797 8.03336 7.85841 7.69586 8.19592C7.35836 8.53342 6.87792 8.60019 6.62277 8.34504L3.99996 5.72223Z",
                fill: "#2C2925",
              },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }